import { useNavigate, NavigateOptions } from 'react-router-dom';
import { useLocale } from '@/contexts/LocaleContext';

/**
 * A locale-aware useNavigate that automatically prepends the current locale prefix.
 */
export const useLocaleNavigate = () => {
  const navigate = useNavigate();
  let getLocalizedPath: ((path: string) => string) | null = null;

  try {
    const ctx = useLocale();
    getLocalizedPath = ctx.getLocalizedPath;
  } catch {
    // Outside LocaleProvider
  }

  return (to: string, options?: NavigateOptions) => {
    let localizedTo = to;
    if (getLocalizedPath && to.startsWith('/') && !to.match(/^\/[a-z]{2}-[A-Z]{2}(\/|$)/)) {
      localizedTo = getLocalizedPath(to);
    }
    navigate(localizedTo, options);
  };
};

export default useLocaleNavigate;
